import dayjs from "dayjs";
import { DeliveryDateSettings } from "../types/DeliveryDateSettings";
import businessDays from "business-days-js";

export function validateDeliveryDate(date: Date | undefined, settings: DeliveryDateSettings): boolean {
	if (!date) return false;

	if (!settings.rangeOfRecurrenceStartDate || date < settings.rangeOfRecurrenceStartDate) {
		return false;
	}
	date = new Date(date.toDateString() + (' ' + (settings.cutoffTime ?? '')));
	let cutoffDate = getCutoffDate(date, settings.cutoffDaysBefore)
	if (new Date() > cutoffDate) {
		return false;
	}

	if (settings.rangeOfRecurrenceStatus === 1 && settings.occurrence) { //Occurrence Qty
		let dateOffset = 0;
		let occurrenceCount = 0;
		while (date > addDays(settings.rangeOfRecurrenceStartDate, dateOffset)) {
			if (validateDeliveryDate(addDays(settings.rangeOfRecurrenceStartDate, dateOffset),
				{
					...settings,
					rangeOfRecurrenceStatus: -1 //Force different rangeOfRecurrenceStatus
				})) {
				occurrenceCount++;
				if (occurrenceCount >= settings.occurrence) {
					return false;
				}
			}
			dateOffset++;
		}
	}
	if (settings.rangeOfRecurrenceStatus === 2 && settings.rangeOfRecurrenceEndDate &&
		date > settings.rangeOfRecurrenceEndDate) { //EndByDate
		return false;
	}

	let startDate = settings.rangeOfRecurrenceStartDate;
	if (settings.recurrencePatternType === 1) { //Daily (weekdays only)
		return checkDay(date, buildWeekDaysArray(31));
	} else if (settings.recurrencePatternType === 2 && settings.recurrenceWeeklyWeekDays) { //Weekly
		if (startDate.getDay() > 0) {
			startDate = addDays(startDate, -1 * startDate.getDay()); //considers first week beginning on sunday of start date
		}
		let timeGap = DateDiff.inWeeks(date, startDate);
		let validWeek = timeGap % (settings.recurrenceWeeklyPeriodicity ?? 1) === 0;
		if (validWeek) {
			return checkDay(date, buildWeekDaysArray(settings.recurrenceWeeklyWeekDays));
		}
	} else if (settings.recurrencePatternType === 3) { //Monthly
		if (date.getDate() === settings.recurrenceMonthlyDay) {
			let monthGap = date.getMonth() - startDate.getMonth();
			let validMonth = monthGap % (settings.recurrenceMonthlyDayOfEveryMonth ?? 1) === 0;
			if (validMonth) {
				return true;
			}
		}
	} else if (settings.recurrencePatternType === 4) { //Yearly
		if (date.getDate() === settings.recurrenceYearlyOnMonthDay &&
			(date.getMonth() + 1) === settings.recurrenceYearlyOnMonth) {
			let yearGap = date.getFullYear() - startDate.getFullYear();
			let validYear = yearGap % (settings.recurrenceYearlyPeriodicity ?? 1) === 0;
			if (validYear) {
				return true;
			}
		}
	}
	return false;
}

export function getCutoffDate(date: Date, cutoffDaysBefore: number | undefined): Date{
	const busiDays = businessDays();	
    let dayJsObj: dayjs.Dayjs = dayjs(date);
	let cutoffDays = (cutoffDaysBefore ?? 0);
	let counter = 0;
    while (counter < cutoffDays) 
	{
		if (busiDays.check(dayJsObj)) {
			counter++;	  
		}
		if (counter <= cutoffDays) {
			dayJsObj = dayJsObj.subtract(1, "day");
		}
    }
    return dayJsObj.toDate();
}

export function getClosestDeliveryDate(settings: DeliveryDateSettings): Date | undefined {

	var date = new Date();
	for (let i = 0; i <= 365; i++) {
		if (validateDeliveryDate(date, settings)) {
			return date;
		}

		date.setDate(date.getDate() + 1);
	}

	return;
}

function addDays(date: Date, days: number) {
	var newDate = new Date(date);
	newDate.setDate(date.getDate() + days);
	return newDate;
}

function buildWeekDaysArray(weekdays: number) {
	let vDays = [];
	for (let i = 0; i < 6; i++) {
		if ((weekdays & (1 << i)) > 0) {
			vDays.push(i + 1);
		}
	}
	return vDays;
}

function checkDay(date: Date, vDays: number[]) {
	var day = date.getDay();
	if (vDays !== undefined) {
		for (var i = 0; i < vDays.length; i++) {
			if (day === vDays[i]) {
				return true;
			}
		}
	}
	return false;
}

var DateDiff = {
	inDays: function (d1: Date, d2: Date) {
		var t2 = d2.getTime();
		var t1 = d1.getTime();
		return Math.floor((t2 - t1) / (24 * 3600 * 1000));
	},
	inWeeks: function (d1: Date, d2: Date) {
		var t2 = d2.getTime();
		var t1 = d1.getTime();
		return Math.floor((t2 - t1) / (24 * 3600 * 1000 * 7));
	},
	inMonths: function (d1: Date, d2: Date) {
		var d1Y = d1.getFullYear();
		var d2Y = d2.getFullYear();
		var d1M = d1.getMonth();
		var d2M = d2.getMonth();
		return (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
	},
	inYears: function (d1: Date, d2: Date) {
		return d2.getFullYear() - d1.getFullYear();
	}
}